/* eslint-disable */
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Box,
    LinearProgress,
    Typography,
    Pagination
} from '@mui/material';

const CommonTable = ({ columns, data, isLoading, totalCount, page, limit, onPageChange, emptyMessage = 'No Data Available' }) => {
    return (
        <Box sx={{ width: '100%' }}>
            <TableContainer component={Paper}>
                {isLoading ? (
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                ) : (
                    <Table stickyHeader aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column, index) => (
                                    <TableCell
                                        key={index}
                                        align={column.align || 'left'}
                                        sx={{ fontWeight: 'bold', ...column.headerStyle }}
                                    >
                                        {column.header}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data?.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={columns.length} align="center">
                                        <Typography variant="body1" sx={{ py: 2 }}>
                                            {emptyMessage}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            ) : (
                                data?.map((row, rowIndex) => (
                                    <TableRow key={rowIndex} hover>
                                        {columns.map((column, colIndex) => {
                                            const value = row[column.key];
                                            return (
                                                <TableCell key={colIndex} align={column.align || 'left'}>
                                                    {column.render ? column.render(row, rowIndex) : value ?? '-'}
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                )}
            </TableContainer>
            {totalCount > 0 && limit > 0 && (
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                    <Pagination count={Math.ceil(totalCount / limit)} page={page} onChange={onPageChange} color="primary" />
                </Box>
            )}
        </Box>
    );
};

export default CommonTable;
